var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVariables = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.872 5.128a.44.44 0 0 1 0 .619L17.869 6.75l1.003 1.003a.437.437 0 1 1-.619.619L17.25 7.369l-1.003 1.003a.437.437 0 1 1-.619-.619l1.003-1.003-1.003-1.003a.438.438 0 0 1 .619-.619l1.003 1.003 1.003-1.003a.44.44 0 0 1 .619 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.635 8.619a.437.437 0 0 0-.62-.002l-7.887 7.886a.437.437 0 0 0 0 .619l1.75 1.75a.44.44 0 0 0 .62 0L13.55 12.8a.44.44 0 0 0 .148-.148l1.662-1.667c.17-.17.17-.445.002-.616zm-.32 3.179 1.12-1.123-1.113-1.128-1.13 1.13zm-1.741-.503-5.518 5.518 1.131 1.13 5.51-5.525z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.872 13.878a.44.44 0 0 1 0 .619L17.869 15.5l1.003 1.003a.437.437 0 1 1-.619.619l-1.003-1.003-1.003 1.003a.437.437 0 1 1-.619-.619l1.003-1.003-1.003-1.003a.438.438 0 0 1 .619-.619l1.003 1.003 1.003-1.003a.44.44 0 0 1 .619 0m-7.875-8.75a.44.44 0 0 1 0 .619L9.994 6.75l1.003 1.003a.438.438 0 0 1-.619.619L9.375 7.369 8.372 8.372a.438.438 0 0 1-.619-.619L8.756 6.75 7.753 5.747a.438.438 0 0 1 .619-.619l1.003 1.003 1.003-1.003a.44.44 0 0 1 .619 0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVariables);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/variables.63803182.svg";